import Vue from "vue"
import Router from "vue-router"
import NotFound from '@/pages/404.vue'; // 你的404组件路径
 
Vue.use(Router)
export default new Router({
    mode:"hash",
    base:process.env.BASE_URL,
    routes:[
        {
            path:'/',
            name:'Index',
            component :()=> import('@/pages/register/index.vue'),
            meta:{
                title:'首页'
            }
        },
        {
            path:'/register',
            name:'register',
            component :()=> import('@/pages/register/index.vue'),
            meta:{
                title:'邀请注册'
            }
        },
        {
            path:'/designers',
            name:'designers',
            component :()=> import('@/pages/designers/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/news',
            name:'news',
            component :()=> import('@/pages/news/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/social',
            name:'social',
            component :()=> import('@/pages/social/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/video',
            name:'video',
            component :()=> import('@/pages/video/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/curriculum',
            name:'curriculum',
            component :()=> import('@/pages/curriculum/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/recording',
            name:'recording',
            component :()=> import('@/pages/recording/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/activity',
            name:'activity',
            component :()=> import('@/pages/activity/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/agreement',
            name:'agreement',
            component :()=> import('@/pages/agreement/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path:'/profile',
            name:'profile',
            component :()=> import('@/pages/profile/index.vue'),
            meta:{
                title:'印际'
            }
        },
        {
            path: '*',
            component: NotFound
        }
    ]
})